<template>
	<div v-if="good_detail">
		<van-sticky>
			<div class="rcst_sc">
				<div @click="backPrev()" class="rcst_sc_drop">
					<div class="rcst_sc_drop_left">
						<img src="../demo1/source/back.png" alt="" />
					</div>
				</div>
				<div class="rcst_sc_drop_center">{{good_detail.className}}</div>
			</div>
		</van-sticky>
		<van-swipe class="detail_swipe" :autoplay="3000" :show-indicators="false">
			<van-swipe-item v-for="(std_item,std_index) in good_detail.thumbsArr" :key="std_item">
				<!-- <div class="detail_swipe_item" :style="'background-image: url('+std_item+');'"></div> -->
				
				<van-image fit="cover" class="detail_swipe_item" :src="std_item"/>
			</van-swipe-item>
		</van-swipe>
		<div class="sdpz default_bg_color">
			<div class="sdpz_title">{{good_detail.goodsName}}</div>
			<div class="sdpz_tips">需预约</div>
			<div class="sdpz_venus">
				<div class="sdpz_venus_title">{{good_detail.venueName}}</div>
				<div :class="[{'sdpz_venus_addressM':good_detail.classId !=1901},'sdpz_venus_address']">
					<div class="sdpz_venus_address_item">
						<div class="sdpz_venus_address_1">{{good_detail.address}}</div>
					</div>
				</div>
				<div v-if="good_detail.classId !=1901" class="sdpz_venus_desc">
					<div>营业时间：</div>
					<div v-html="good_detail.businessTimeDesc"></div>
				</div>
				<div v-if="good_detail.classId !=1901" class="sdpz_venus_desc">
					<div>服务介绍：</div>
					<div v-html="good_detail.swimmingPoolServiceDesc"></div>
				</div>
			</div>
			<div v-if="dateList.length>0" class="rcst_date">
				<div v-for="(std_item,std_index) in dateList" :key="std_item.timp"
					:class="[{'rcst_date_itemS':date_index==std_index},'rcst_date_item']"
					@click="selectSportTypeDate(std_index)">
					<div>
						<div class="rcst_date_item_1">{{std_item.date_obj.week}}</div>
						<div :class="[{'rcst_date_item_2S':date_index==std_index},'rcst_date_item_2']">{{std_item.date_obj.date_ndateD}}</div>
					</div>
				</div>
			</div>


			<div class="sdpz_rule">
				<!-- <div class="sdpz_rule_head">
					<div @click="switchRuleType(1)"
						:class="[{'sdpz_rule_head_itemS':rule_type==1},'sdpz_rule_head_item']">
						
						<div v-if="rule_type==1"></div>
					</div>
					<div @click="switchRuleType(2)"
						:class="[{'sdpz_rule_head_itemS':rule_type==2},'sdpz_rule_head_item']">
						
						<div v-if="rule_type==2"></div>
					</div>
				</div> -->
				<div class="sdpz_rule_cont">
					<div class="sdpz_rule_cont_title">预约须知</div>
					<!-- <div v-if=""></div>
					<div v-else-if=""></div> -->
					<div v-if="good_detail.classId==1901">
						请至少提前一天预约，具体房间需根据酒店实际运营情况安排。
					</div>
					<div v-else-if="good_detail.rules.note_to_book" v-html="good_detail.rules.note_to_book"></div>
					<div v-else>内容正在赶来的路上</div>
					<div class="sdpz_rule_cont_title">退订规则</div>
					<div v-if="good_detail.rules.note_to_refund" v-html="good_detail.rules.note_to_refund"></div>
					<div v-else>请在预约时间前24小时进行退订，超出视为已使用。</div>
				</div>
			</div>
			<div class="sdpz_sub">
				<!-- <div class="sdpz_sub_pri">
					　
				</div> -->
				<div @click="openStockTime()" class="sdpz_sub_btn">选择时间</div>
			</div>
		</div>

		<van-popup v-model="stock_show" position="bottom" @close="closeStockTime">
			<div v-if="dateList && dateList.length>0" class="sdpz_sub_pri_time_out">
				<van-row>
					<van-col span="6" v-for="(item_time,index_time) in dateList[date_index].times" :key="item_time">
						<div class="sdpz_sub_pri_time_1">
							<div @click="toSplCreateOrder(item_time)" :class="[{'sdpz_sub_pri_timeN':dateList[date_index].stock<=0},'sdpz_sub_pri_time']">{{item_time}}</div>
						</div>
					</van-col>
				</van-row>
				<!-- <div :class="[{'sdpz_sub_pri_time_btnN':dateList[date_index].stock<=0},'sdpz_sub_pri_time_btn']">立即预约</div> -->
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		futureTimesGroup,
		datePrintStr
	} from "../../lib/utils.js"
	export default {
		data() {
			return {
				rule_type: 1,
				date_list: futureTimesGroup(7),

				date_index: 0,
				goodsId: '',
				good_detail: null,
				stock_show: false,
				dateList: [],
				times: [
					'08:00', '09:00', '10:00', '08:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00',
					'18:00', '19:00', '20:00',
				]
			}
		},
		mounted() {
			
			this.$loading('正在加载中...');
			// console.log(futureTimesGroup(7));
			// console.log(this.$route.params);
			this.goodsId = this.$route.params.goodsId
			// this.date_index=this.$route.params.index
			this.getDetail()
		},
		methods: {
			backPrev(){
				this.$router.go(-1)
			},
			getDetail() {
				var $this = this
				var param = {
					goods_id: this.goodsId
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_getVenueGoodsInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						$this.good_detail = res.data
						
						if(res.data.class_id==1101){
							document.title='五星酒店游泳健身'
						}else if(res.data.class_id==1901){
							document.title='五星酒店SPA'
						}else if(res.data.class_id==1702){
							document.title='连锁健身房'
						}
						
						$this.loadStock()
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			},
			loadStock() {
				var $this = this
				var param = {
					goods_id: this.goodsId
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_getVenueGoodsStocks
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						if(res.data && res.data.stock){
							var s1101 = res.data.stock
							s1101.map((item) => {
								item.date_obj = datePrintStr(item.date)
							})
							// console.log(s1101);
							$this.dateList = s1101
						}
						
						$this.$loading.close();

					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						if(error.code==200105){
							
						}else{
							$this.$toast(error.msg?error.msg:error.message);
						}
					})
			},
			selectSportTypeDate(e) {
				this.date_index = e
			},
			switchRuleType(e) {
				this.rule_type = e
			},
			openStockTime() {
				if(this.dateList.length>0){
					this.stock_show = true
				}else{
					this.$toast('暂未配置库存');
				}
				
			},
			closeStockTime() {
				this.stock_show = false
			},
			toSplCreateOrder(e) {
				// console.log(e);
				// return
				if(this.dateList[this.date_index].stock<=0){
					return
				}
				this.$router.push({
					name: 'venue_goods_createorder',
					params: {
						goodsId: this.good_detail.goodsId,
						date:this.dateList[this.date_index].date,
						time:e
					}
				})
				return
				if(localStorage.getItem('token') && localStorage.getItem('phone')){
					this.$router.push({
						name: 'venue_goods_createorder',
						params: {
							goodsId: this.good_detail.goodsId,
							date:this.dateList[this.date_index].date,
							time:e
						}
					})
				}else{
					var params={
						goodsId: this.good_detail.goodsId,
						date:this.dateList[this.date_index].date,
						time:e
					}
					// console.log(params);
					// localStorage.setItem('dparams2',JSON.stringify(params))
					localStorage.removeItem('dparams2')
					localStorage.setItem('dparams',JSON.stringify(params))
					// return
					this.$router.push({
						name: 'venue_goods_login',
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		padding: 0 30*@vm_base;
		// padding: 0 0 20*@vm_base 0;
		background-color: #fff;
		
		display: flex;
		justify-content: space-between;
		align-items: center;
	
		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;
			
			.rcst_sc_drop_left{
				width: 80*@vm_base;
				height: 80*@vm_base;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				img{
					width: 36*@vm_base;
				}
			}
		}
		.rcst_sc_drop_center{
			width: calc(100% - 80*@vm_base);
			height: 80*@vm_base;
			padding-right: 80*@vm_base;
			font-size: 28*@vm_base;
			color: #666666;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.detail_swipe {
		.van-swipe-item {
			width: 100%;
			height: 480*@vm_base;
		}

		.detail_swipe_item {
			width: 100%;
			height: 480*@vm_base;
			// background-size: 100%;
			// background-repeat: no-repeat;
			// background-position: center;
		}
	}



	.sdpz {
		position: relative;
		width: 100%;
		padding: 30*@vm_base 20*@vm_base 160*@vm_base 20*@vm_base;
		// margin-top: -30*@vm_base;
		border-radius: 16*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 160*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 160*@vm_base);



		.rcst_date {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			// padding: 0 30*@vm_base;
			padding: 20*@vm_base;
			background-color: #FFFFFF;
			border-radius: 16*@vm_base;
			margin-top: 20*@vm_base;

			.rcst_date_item {
				width: 80*@vm_base;
				height: 92*@vm_base;
				border-radius: 16*@vm_base;
				display: flex;
				justify-content: center;
				align-items: center;
				text-align: center;
				color: #666666;
				border: 1*@vm_base solid transparent;
			}

			.rcst_date_itemS {
				border: 1*@vm_base solid #F77F28;
				color: #F77F28;
			}

			.rcst_date_item_1 {
				font-size: 20*@vm_base;
			}

			.rcst_date_item_2 {
				font-size: 30*@vm_base;
				margin-top: 6*@vm_base;
			}
			.rcst_date_item_2S{
				font-weight: bold;
			}
		}



		.sdpz_title {
			width: 100%;
			font-weight: 600;
			font-size: 36*@vm_base;
			color: #333333;
			padding: 0 10*@vm_base;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.sdpz_tips {
			font-size: 24*@vm_base;
			color: #999999;
			padding: 20*@vm_base 10*@vm_base 0 10*@vm_base;
		}

		.sdpz_venus {
			width: 100%;
			margin-top: 30*@vm_base;
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 30*@vm_base 20*@vm_base 20*@vm_base 20*@vm_base;
		}

		.sdpz_venus_title {
			font-size: 30*@vm_base;
			color: #333333;
		}

		.sdpz_venus_address {
			width: 100%;
			font-size: 24*@vm_base;
			color: #999999;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding: 20*@vm_base 0 0 0;
			
		}
		.sdpz_venus_addressM{
			margin-bottom: 30*@vm_base;
			border-bottom: 1*@vm_base solid #D9D9D9;
			padding-bottom: 30*@vm_base;
		}

		.sdpz_venus_addressN {
			padding: 20*@vm_base 0 10*@vm_base 0;
			margin-bottom: 0;
			border-bottom: none;
		}

		.sdpz_venus_address_item {
			max-width: 100%;
			width: fit-content;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			background-repeat: no-repeat;
			background-position: right center;
			background-size: auto 100%;
			// padding-right: 78*@vm_base;
			line-height: 1.5;
		}

		.sdpz_venus_address_1 {
			width: fit-content;
			max-width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			line-height: 1.5;
		}

		.sdpz_venus_address_2 {
			padding: 0 0 0 20*@vm_base;
			white-space: nowrap;
			line-height: 1.5;
		}

		.sdpz_venus_desc {
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			font-size: 28*@vm_base;
			color: #333333;
			margin-bottom: 10*@vm_base;
		}

		.sdpz_venus_desc0 {
			margin-top: 30*@vm_base;
		}

		.sdpz_venus_desc div {
			line-height: 1.5;
		}

		.sdpz_venus_desc div:first-child {
			color: #999999;
			white-space: nowrap;
		}

		.sdpz_venus_service2 {
			width: calc(100% + 40*@vm_base);
			margin-left: -20*@vm_base;
			height: 100*@vm_base;
			white-space: nowrap;
			vertical-align: top;
		}

		.sdpz_venus_service2_item {
			display: inline-block;
			margin-right: 20*@vm_base;
		}

		.sdpz_venus_service2_item:first-child {
			margin-left: 20*@vm_base;
		}

		.sdpz_venus_service2_block {
			width: 90*@vm_base;
			height: 90*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			border-radius: 8*@vm_base;
			border: 1*@vm_base solid #d9d9d9;
			font-size: 20*@vm_base;
			color: #666666;
			margin-bottom: 8*@vm_base;
		}

		.sdpz_venus_service2_block_img {
			width: 36*@vm_base;
			height: 36*@vm_base;
		}

		.sdpz_rule {
			width: 100%;
			margin-top: 20*@vm_base;
		}

		.sdpz_rule_head {
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			padding: 20*@vm_base 10*@vm_base 0 10*@vm_base;
		}

		.sdpz_rule_head_item {
			font-size: 28*@vm_base;
			color: #666666;
			padding-bottom: 30*@vm_base;
			margin-right: 70*@vm_base;
		}

		.sdpz_rule_head_itemS {
			color: #F77F28;
			position: relative;
		}

		.sdpz_rule_head_itemS view {
			position: absolute;
			bottom: 30*@vm_base;
			left: 0;
			margin-left: calc(50% - 30*@vm_base);
			width: 60*@vm_base;
			height: 6*@vm_base;
			background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 3*@vm_base;
		}

		.sdpz_rule_cont {
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 30*@vm_base;
			font-size: 26*@vm_base;
			color: #666666;
			line-height: 1.7;

			.sdpz_rule_cont_title {
				font-size: 32*@vm_base;
				color: #333333;
				font-weight: bold;
			}
		}

		.sdpz_rule_cont div {
			line-height: 1.7;
		}

		.sdpz_sub {
			width: 100%;
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			height: calc(constant(safe-area-inset-bottom) / 2 + 130*@vm_base);
			height: calc(env(safe-area-inset-bottom) / 2 + 130*@vm_base);
			background: #FFFFFF;
			padding: 0 20*@vm_base 0 30*@vm_base;
			padding-bottom: calc(constant(safe-area-inset-bottom) / 2);
			padding-bottom: calc(env(safe-area-inset-bottom) / 2);
			border-radius: 16*@vm_base;
			display: flex;
			justify-content: space-between;
			align-items: center;
			box-shadow: -4px -4px 6px rgba(243, 207, 166, 0.5);
		}

		.sdpz_sub_pri {
			display: flex;
			justify-content: center;
			align-items: flex-end;
		}

		.sdpz_sub_pri_1 {
			font-size: 24*@vm_base;
			color: #F77F28;
			line-height: 1.4;
		}

		.sdpz_sub_pri_2 {
			font-size: 54*@vm_base;
			color: #F77F28;
			padding: 0 4*@vm_base;
		}

		.sdpz_sub_pri_3 {
			font-size: 24*@vm_base;
			color: #999999;
			padding-left: 20*@vm_base;
			line-height: 1.4;
		}

		.sdpz_sub_btn {
			width: 100%;
			height: 80*@vm_base;
			background: linear-gradient(319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 34*@vm_base;
			color: #FFFFFF;
		}
	}

	.sdpz_sub_pri_time_out {
		width: 100%;
		padding: 80*@vm_base 30*@vm_base;
		.sdpz_sub_pri_time_1{
			width: 100%;
			padding: 0 10*@vm_base;
		}
		.sdpz_sub_pri_time {
			width: 100%;
			padding: 20*@vm_base 0;
			border: 1*@vm_base solid #d9d9d9;
			border-radius: 16*@vm_base;
			margin-bottom: 30*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28*@vm_base;
			color: #666666;
		}
		.sdpz_sub_pri_timeN{
			opacity: 0.5;
		}
		.sdpz_sub_pri_time_btn{
			width: 100%;
			height: 80*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 32*@vm_base;
			color: #fff;
			background-color: #F77F28;
			margin-top: 30*@vm_base;
			border-radius: 40*@vm_base;
		}
		.sdpz_sub_pri_time_btnN{
			opacity: 0.5;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/detail.vue